import { render, staticRenderFns } from "./often-win-gold.vue?vue&type=template&id=402b7d2c&scoped=true&"
import script from "./often-win-gold.vue?vue&type=script&lang=js&"
export * from "./often-win-gold.vue?vue&type=script&lang=js&"
import style0 from "./often-win-gold.vue?vue&type=style&index=0&id=402b7d2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402b7d2c",
  null
  
)

export default component.exports